<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="fut_toc"> </p>
<p class="fut_toc1"><a href="#/xhtml/dedication">Begin Reading</a></p>
<p class="fut_toc1"><span href="#/xhtml/contents" title="Link target outside of Sample">Table of Contents</span></p>
<p class="fut_toc1"><span href="#/xhtml/abouttheauthor" title="Link target outside of Sample">A Note About the Author and Translators</span></p>
<p class="fut_toc-sp"><span href="#/xhtml/copyright" title="Link target outside of Sample">Copyright Page</span></p>
<p class="fut_tit"><a href="http://us.macmillan.com/static/ebooks/WIP/index.html?utm_source=ebook&amp;utm_medium=backad&amp;utm_term=na-wipsignup&amp;utm_content=fullpg-signup-nl&amp;utm_campaign=wipsignup&amp;et=27109-n15162182" target="_blank"><img alt="image" class="img90" src="images/WIP-NewsletterSignup.jpg"/></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// mini_toc.vue?3d5a1b72